export default __webpack_public_path__ + "static/media/7.e10f62b1.jpg";